import * as React from 'react'

import { type VariantProps, tv } from 'tailwind-variants'

import LogoTextIcon from '@wwt/shared/assets/icons/logos/logo-text.svg'
import LogoIcon from '@wwt/shared/assets/icons/logos/logo.svg'

// eslint-disable-next-line react-refresh/only-export-components
export const logoVariants = tv({
	slots: {
		base: 'flex items-center',
		logo: 'shrink-0 text-primary-accent',
		text: 'shrink-0'
	},
	variants: {
		size: {
			default: {
				base: 'gap-3',
				logo: 'size-10',
				text: 'h-10 w-[18.125rem]'
			},
			xs: {
				base: 'gap-[5px]',
				logo: 'size-5',
				text: 'h-3.5 w-[6.5625rem]'
			},
			sm: {
				base: 'gap-1.5',
				logo: 'size-6',
				text: 'h-6 w-[11.25rem]'
			},
			lg: {
				base: 'gap-4',
				logo: 'size-14',
				text: 'h-[3.375rem] w-[25.25rem]'
			}
		}
	},
	defaultVariants: {
		size: 'default'
	}
})

export interface LogoProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof logoVariants> {
	ref?: React.RefObject<HTMLDivElement>
	withText?: boolean
	slots?: {
		base?: string
		logo?: string
		text?: string
	}
}

export const Logo = ({
	ref,
	className,
	size,
	withText,
	slots,
	...props
}: LogoProps) => {
	const { base, logo, text } = logoVariants({ size, className })

	return (
		<div
			className={base({ className: slots?.base })}
			ref={ref}
			{...props}
		>
			<LogoIcon className={logo({ className: slots?.logo })} />
			{withText && (
				<LogoTextIcon className={text({ className: slots?.text })} />
			)}
		</div>
	)
}
Logo.displayName = 'Logo'
